<x-notification>
  <h3 xHeading>Delivery Options</h3>
  <x-close-button xHeaderAction (click)="closeNotification()"></x-close-button>

  <section class="body">
    <div class="delivery-option">
      <h4>Next Day Delivery</h4>
      <div class="price">
        <strong>{{ shippingMethodContext?.nextDayFee }}&nbsp;</strong>
        <span class="order-time">order by 12:00 noon</span>
      </div>
      <div class="delivery-days">Delivered next day Monday - Saturday</div>
    </div>

    <div class="delivery-option">
      <h4>Standard Delivery</h4>
      <div class="price">
        <strong>{{ shippingMethodContext?.standardFee }}&nbsp;</strong>
        <span class="threshold">for orders under {{ shippingMethodContext?.freeThreshold }}</span>
      </div>
      <div class="free-threshold">
        <strong><i>Free</i></strong>
        for orders over {{ shippingMethodContext?.freeThreshold }}
      </div>
      <div class="delivery-days">Delivered in 2 days Monday - Saturday</div>
      <div class="checkout-note">Select your delivery day during checkout</div>
    </div>
  </section>

  <button xFooterAction type="button" mat-button xButtonType="link" xNeedHelp color="primary">
    <fa-icon icon="question"></fa-icon>
    <span i18n="@@CallToAction.NeedHelp">Need help?</span>
  </button>
</x-notification>
